import { render, staticRenderFns } from "./AzPeriodo.vue?vue&type=template&id=03689b06&"
import script from "./AzPeriodo.vue?vue&type=script&lang=js&"
export * from "./AzPeriodo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports